import en from "./en.json";
import ko from "./ko.json";

export type SiteLocale = "en" | "ko";

const bundles: Record<SiteLocale, Record<string, string>> = { en, ko };

export function loadSiteMessages(locale: SiteLocale): Record<string, string> {
  return bundles[locale] ?? bundles.en;
}

export function detectSiteLocale(): SiteLocale {
  if (typeof navigator === "undefined") return "en";
  const lang = navigator.language.toLowerCase();
  if (lang.startsWith("ko")) return "ko";
  return "en";
}
